import { NgModule } from '@angular/core';

import { UrlCachePipe } from './url-cache-pipe';

@NgModule({
    declarations: [
        UrlCachePipe
    ],
    exports: [
        UrlCachePipe
    ]
})
export class UrlCachePipeModule {
}
